import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Grid } from '@mui/material';
import { PageContainer, FilterPod, TableComponents } from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns, generateData } from './componenets/Columns';
import Services from '../services/Services';
import InitFilters from './constants/InitFiltering';
import { enifyDateTime, getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { useStyles } from './style';
import { LoanInstallmentDialog } from './componenets';
import FilterButton from 'components/FilterPod/FilterButton';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

/**
 * منوی تامین مالی - زیر منوی درخواست تامین مالی
 */
export default function FainancialInvoices() {
  //-- STATES --//
  let tableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(InitFilters());
  const [openDialog, setOpenDialog] = useState(false);
  //--HOOKS--//
  const classes = useStyles();
  const [selectedRow, setSelectedRow] = useState(null);
  const currencyText = useCurrencyUnit();
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  /**
   * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
   */
  const actionsList = getDynamicObjectAction(['invoiceFinancingPage', 'invoiceFinancingPayAction']);

  useEffect(() => {
    !openDialog && setSelectedRow(null);
  }, [openDialog]);
  /**
   * دریافت لیست دیتای جدول
   */
  const getList = async (query) => {
    try {
      setLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };
      filters[0].value?.start &&
        (params['fromDate'] = enifyDateTime(
          filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00'),
        ));
      filters[0].value?.end &&
        (params['toDate'] = enifyDateTime(
          filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:59'),
        ));

      setFilterParams({ data, params });
      const res = await Services.getLaonInvoce(params);

      let list = [];
      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const PayBtn = ({ row }) => {
    return (
      <Button onClick={() => onOpenLoaonDg(row)} variant="contained" className={classes.expandBtn}>
        مشاهده و پرداخت اقساط
      </Button>
    );
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };
  const onOpenLoaonDg = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const hint =
    'در این صفحه لیستی از فاکتورهایی که به صورت اقساطی پرداخت شده اند نمایش داده می شود.';

  return (
    <>
      <PageContainer
        title="فاکتورهای تأمین مالی شده"
        description={hint}
        breadcrumbs={constBreadCrumbsTitle.FINANCIALSUPPLY_INVOICEFINANCING_INVOICES}
        className={classes.root}
      >
        {actionsList['invoiceFinancingPage'] && (
          <>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="end"
                alignItems="flex-end"
                style={{ marginBottom: 16 }}
              >
                <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
              </Box>
              <Box>
                <FilterPod
                  filters={filters}
                  onChange={onFiltersChange}
                  openFilterDialog={openFilterDialog}
                  setOpenFilterDialog={setOpenFilterDialog}
                  handleCloseFilterDialog={handleCloseFilterDialog}
                />
              </Box>
            </Grid>
            {currencyText && (
              <TableComponents
                data={getList}
                columns={columns(PayBtn, actionsList, currencyText)}
                isLoading={loading}
                ref={tableRef}
                onChange={(ps) => {
                  setPage(ps?.pageNumber);
                  setSize(ps?.pageSize);
                  return getList(ps);
                }}
              />
            )}
          </>
        )}
      </PageContainer>
      <LoanInstallmentDialog open={openDialog} setOpen={setOpenDialog} loan={selectedRow} />
    </>
  );
}
